import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-comment\"><path d=\"M4 5h8v1H4zm0 2h6v1H4z\" /><path d=\"M12 3c.6 0 1 .4 1 1v5c0 .6-.5 1-1 1H8.6L6 12.5V10H4c-.6 0-1-.4-1-1V4c0-.6.5-1 1-1zm0-1H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h1v3.9L9 11h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol